import DataRoomInvitations from './DataRoomInvitations.component';

export default DataRoomInvitations;